import {
  GxButton,
  GxIcon,
  GxPhoneInput,
  GxTabPanel,
  GxTextarea
} from '@garpix/garpix-web-components-react'
import cnBind from 'classnames/bind'
import { FormikProps } from 'formik'
import React, { FC, useEffect, useState } from 'react'
import 'react-responsive-modal/styles.css'
import { useStoreon } from 'storeon/react'
import { MODAL_USER_PANELS, TYPE_USER } from '@/const'
import { CustomElementEvent } from '@/types'
import InputForm from '@/components/InputForm'
import CalendarInputForm from '@/components/CalendarInputForm'
import RadioForm from '@/components/RadioForm'
import SelectTypeUser from '@/apps/Applications/components/ModalUser/ModalUserTabPanels/SelectTypeUser'
import { genderOptions } from '@/apps/Applications/components/ModalUser/helpers'
import { Events, State } from '@/interfaces'
import { api } from '@/api'
import { PhoneIcon, QuestionnaireIcon, TubeIcon, WaveIcon } from '../../../../../assets'
import FormError from '../../../../../components/FormError'
import Switcher from '../../../../../components/Switcher'
import { userTypeFormater } from '../../../helpers'
import styles from '../styles/index.module.scss'
import { IInitialValues } from '../types'
import SelectFindOut from '../../../../../components/ModalInformationCall/components/SelectFindOut'

interface IDataPanel {
  formik: FormikProps<IInitialValues>
}

export type TUserTypeState = {
    icon: string | null;
    id: number;
    label: string;
    value: string;
};

export type TUserTypesState = {
    tubeArr: Array<TUserTypeState>;
    waveArr: Array<TUserTypeState>;
};


const DataPanel: FC<IDataPanel> = ({ formik}) => {
    const cn = cnBind.bind(styles);

    const { values, handleChange, errors, setFieldValue } = formik;

    const { dispatch, currentUser} = useStoreon<State, Events>('currentUser');

    const [userTypes, setUserTypes] = useState<TUserTypesState>({
        tubeArr: [],
        waveArr: []
    });

    const getUserTypes = async () => {
        const { results } = await api.user.getUserTypes();

        setUserTypes({
            tubeArr: userTypeFormater(results, TubeIcon),
            waveArr: userTypeFormater(results, WaveIcon)
        });
    };

    useEffect(() => {
        getUserTypes();
    }, []);

    const openModalCall = (): void => {
        dispatch('modalCall/show', true)
        dispatch('modalCall/setInfo', {
            type: 'DEFAULT',
            phone: formik.values.user.phone
        });
    }

    return (
        <GxTabPanel name={MODAL_USER_PANELS.data}>
            <div className={styles['user']}>
                <div className={styles['user--container']}>
                    <InputForm
                        label='Фамилия:'
                        name='user.last_name'
                        className={styles['item']}
                        errorContainerClassName={styles['user--errors']}
                        formik={formik}
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                    />
                    <InputForm
                        formik={formik}
                        label='Имя:'
                        name='user.first_name'
                        className={styles['item']}
                        errorContainerClassName={styles['user--errors']}
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                    />
                    <InputForm
                        formik={formik}
                        label='Отчество:'
                        name='user.patronymic_name'
                        className={styles['item']}
                        errorContainerClassName={styles['user--errors']}
                        handleChange={(e: Record<string, any>) =>
                            setFieldValue('user.patronymic_name', e.target.value)
                        }
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                    />
                    <div className={styles['user--group']}>
                        <div className={styles['birth-date']}>
              <span className={styles['birth-date--label']}>
                Дата рождения:
              </span>
                            <CalendarInputForm
                                formik={formik}
                                onOpenPickNewDate={false}
                                name='user.birthday'
                                disabled={currentUser.user_status === TYPE_USER.VIEWER}
                                readOnly={false}
                                type='sm_l'
                                clear={() => setFieldValue('user.birthday', undefined)}
                            />
                        </div>
                        <div className={styles['user--sex']}>
                            {genderOptions.map((elem) => {
                                return (
                                    <RadioForm
                                        key={elem.value}
                                        formik={formik}
                                        name='user.sex'
                                        value={elem.value}
                                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                                    >
                                        {elem.label}
                                    </RadioForm>
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles['user--partner']}>
                        <span className={styles['partner--label']}>Тип:</span>
                        <div className={styles['partner--selects']}>
                            <SelectTypeUser
                                formik={formik}
                                className={styles['partner--select']}
                                options={userTypes.tubeArr}
                                isDisabled={currentUser.user_status === TYPE_USER.VIEWER}
                                name='user.tube_user_type'
                            />
                            <SelectTypeUser
                                formik={formik}
                                className={styles['partner--select']}
                                options={userTypes.waveArr}
                                name='user.wave_user_type'
                                isDisabled={currentUser.user_status === TYPE_USER.VIEWER}
                            />
                        </div>
                    </div>
                    <div className={styles['divide--wrap']}>
                        <div className={styles['divide--line']} />
                    </div>
                    <div
                        className={cn(styles['user--group'], styles['user--group_phone'])}
                    >
                        <label htmlFor='test' className={styles['phone']}>
                            <span>Телефон:</span>
                            <GxPhoneInput
                                disabled={currentUser.user_status === TYPE_USER.VIEWER}
                                onGx-change={(e: any) =>
                                    setFieldValue('user.phone', `${e?.detail?.value}`)
                                }
                                country='ru'
                                className={cn({
                                    'phone--input': true
                                })}
                                value={values.user.phone}
                            />
                        </label>
                        <GxButton
                            className={styles['phone--btn']}
                            onClick={openModalCall}
                            disabled={currentUser.user_status === TYPE_USER.VIEWER}
                        >
                            <GxIcon src={PhoneIcon} className={styles['phone--icon']} />
                        </GxButton>
                    </div>
                    {errors.user?.phone && (
                        <div className={styles['user--errors']}>
                            <FormError text={errors.user?.phone} />
                        </div>
                    )}
                    <InputForm
                        formik={formik}
                        label='E-mail:'
                        name='user.email'
                        className={styles['item']}
                        errorContainerClassName={styles['user--errors']}
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                    />
                    <div className={styles['user--partner']}>
                        <span className={styles['partner--label']}>Откуда узнали</span>
                        <div className={styles['partner--select_how']}>
                            <SelectFindOut
                                onChange={(option: any): any => {
                                    setFieldValue('user.source_of_traffic', option || undefined);
                                }}
                                value={formik.values.user.source_of_traffic}
                                disable={currentUser.user_status === TYPE_USER.VIEWER}
                            />
                        </div>
                    </div>
                    <GxTextarea
                        label='Комментарий:'
                        name='user.comment'
                        onGx-change={handleChange}
                        className={cn(styles['item'], styles['text-area'])}
                        value={values.user.comment}
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                        resize='none'
                    />
                    <div
                        className={cn(
                            styles['user--group'],
                            styles['user--group_checkbox']
                        )}
                    >
                        <Switcher
                            disabled={currentUser.user_status === TYPE_USER.VIEWER}
                            onGx-change={(e: CustomElementEvent<any>) =>
                                setFieldValue('user.is_news_email', e?.target?.checked)
                            }
                            label='Подписка на новости:'
                            checked={values.user.is_news_email}
                        />
                    </div>
                </div>
            </div>
            <div className={styles['subheader']}>
                <GxIcon className={styles['subheader--icon']} src={QuestionnaireIcon} />
                <span className={styles['subheader--subtitle']}> Анкеты:</span>
            </div>
            <div className={styles['actions-file']}>
                <div className={styles['actions-file--container']}>
                    <span className={styles['actions-file--label']}>Труба:</span>
                    <CalendarInputForm
                        formik={formik}
                        name='user.acceptance_date_for_airtube'
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                        readOnly={false}
                        type='sm_l'
                        clear={() =>
                            setFieldValue('user.acceptance_date_for_airtube', undefined)
                        }
                    />
                </div>
                <div className={styles['actions-file--container']}>
                    <span className={styles['actions-file--label']}>Волна:</span>
                    <CalendarInputForm
                        formik={formik}
                        name='user.acceptance_date_for_wave'
                        disabled={currentUser.user_status === TYPE_USER.VIEWER}
                        readOnly={false}
                        type='sm_l'
                        clear={() =>
                            setFieldValue('user.acceptance_date_for_wave', undefined)
                        }
                    />
                </div>
            </div>
        </GxTabPanel>
    );
};

export default DataPanel
